module.exports = __webpack_public_path__ + "img/benefits01-04.71d3229.webp";